import _ from 'lodash';
import requestsActions from './requests';
import {
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  REDIRECT_NOTIFICATION,
  UPDATE_NOTIFICATION,
  CUSTOM_ACTION_NOTIFICATION,
} from '../types';
import history from '../../history';

const hideNotification = function hideNotification() {
  return function hideNotificationFunction(dispatch, getState) {
    const {
      notify: {
        show,
      },
    } = getState();
    if (show === true) {
      dispatch({
        type: HIDE_NOTIFICATION,
      });
    }
  };
};

/**
 * Show notifications
 * @param  {String}    message          The message of the notification
 * @param  {Any}       [autoHide=false] The boolean on whether it should auto hide, or number in milliseconds
 * @param  {Object}    [options={}]     The options object
 *
 * @example options:
 *
 *      sound: React.PropTypes.oneOf([
 *        'notification',
 *      ]),
 *      type: React.PropTypes.oneOf([
 *        'info',
 *        'primary',
 *        'danger',
 *        'success',
 *        'warning',
 *      ]),
 *      location: React.PropTypes.oneOf([
 *        'top-center',
 *        'top-left',
 *        'top-right',
 *        'bottom-center',
 *        'bottom-left',
 *        'bottom-right',
 *      ]),
 *      action: React.PropTypes.string,        // Any actions that should be dispatched on click
 *      actionLabel: React.PropTypes.string,   // Label for the action
 *      actionPayload: React.PropTypes.object, // Action payload object
 *      showClose: React.PropTypes.bool,       // Show the close button
 */
const showNotification = function showNotification(message, autoHide = false, options = {}) {
  return function showNotificationFunction(dispatch, getState) {
    const {
      notify,
      notify: {
        show,
      },
    } = getState();
    // only show one notification at a time
    if (show === true) {
      dispatch(hideNotification());
    }
    if (autoHide !== false) {
      const hideTimeout = _.isNumber(autoHide) ? autoHide : 7500;
      window.setTimeout(() => {
        dispatch(hideNotification());
      }, hideTimeout);
    }

    const restOptions = _.omit(options, ['custom', 'args']);
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: {
        ...notify,
        ...restOptions,
        message,
        ...(options.custom ? {
          action: CUSTOM_ACTION_NOTIFICATION,
          actionPayload: {
            action: options.custom,
            args: options.args,
          },
        } : {}),
      },
    });
  };
};

const notifyAction = function notifyAction(action, actionPayload) {
  return function notifyActionFunction(dispatch) {
    if (action === REDIRECT_NOTIFICATION &&
      _.has(actionPayload, 'url') &&
      !_.isNull(actionPayload.url)
    ) {
      history.push(actionPayload.url);
    }

    if (action === CUSTOM_ACTION_NOTIFICATION) {
      return dispatch(actionPayload.action(...actionPayload.args));
    }

    if (action === UPDATE_NOTIFICATION
      && _.has(actionPayload, 'type')
      && _.has(actionPayload, 'id')
      && _.has(actionPayload, 'data')
    ) {
      if (actionPayload.type === 'requests') {
        dispatch(requestsActions.updateRequest(actionPayload.id, actionPayload.data));
      }
    }

    if (_.get(actionPayload, 'hideNotification') === true) {
      dispatch(hideNotification());
    }

    return dispatch({
      type: action,
    });
  };
};

export default {
  showNotification,
  hideNotification,
  notifyAction,
};



// WEBPACK FOOTER //
// ./src/state/actions/notify.js